





























































































import { Component } from 'vue-property-decorator';
import PartnersFilter from "@/components/Settings/Partners/PartnersFilter.vue";
import {ScrollButton} from "wings-ui-components";
import {Getter} from "vuex-class";
import {PartnerItem} from "@/store/settings/partners/types";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import ActionUsersFilter from "@/components/UserManagement/ActionUsers/ActionUsersFilter.vue";

@Component({components:{ActionUsersFilter, PartnersFilter,ScrollButton}})
export default class Partners extends BaseItemsPage<PartnerItem> {
  @Getter("partners") partnersResponse: any;
  private is_show_filter = false;
  currentSort= "id";
  currentSortOrder= "desc";

  tableFields = [
    'id',
    'name',
    'transport_names',
    'status',
  ];

  getData(): any {
    return this.partnersResponse;
  }
}
